import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Box, Button, Grid, List, ListItem, Modal, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckboxComponent from "../../../components/checkbox/checkbox";

import featuredInvite from "../../../assets/images/featuredInvite.svg";
import featuredCancel from "../../../assets/images/featuredCancel.svg";
import featuredDone from "../../../assets/images/featuredDone.svg";
import arrowCircleRightDark from "../../../assets/images/arrowCircleRightFill.svg";

const styleCancel = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 544,
  color: "rgba(255, 255, 255, 0.87)",
  bgcolor: "#0F0F0F",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  "&:focus-visible": {
    outline: "none",
  },
  "@media(max-width: 599px)": {
    width: "90%",
  },
};

const CancelMembershipModal = ({
  handleClose,
  openCancel,
  setOpenCancel,
  onCancleMember,
  getYearDiscountMembership,
  handleGoBack,
  handleCancleMember,
}) => {
  const navigate = useNavigate();
  const [termAgreement, setTermsAgreement] = useState(false);

  const goToReferral = () => navigate("/settings/referral-links");

  return (
    <Modal open={openCancel} onClose={handleClose} className="cancelMembershipModal backdrop">
      <Box sx={styleCancel}>
        <Box
          className="modalHeader"
          px={{sm: 3, xs: 2}}
          mt={{sm: 3, xs: 2}}
          display="flex"
          alignItems="flex-start"
          mr={1}
        >
          <img
            src={openCancel === "invite" ? featuredInvite : openCancel === "cancel" ? featuredCancel : featuredDone}
            alt="featured"
          />
          <Box ml={2}>
            <Typography variant="h4" mb={1}>
              {openCancel === "invite"
                ? "Wait! Earn a free membership instead."
                : openCancel === "cancel"
                ? "Cancel subscription"
                : "Hold up! Get 50% off one year."}
            </Typography>
            {openCancel === "invite" ? (
              <>
                <Typography variant="h6">
                  By referring 3 friends to buythedip.com, your membership is free. Members have previously accomplished this in under a week. *
                </Typography>
                <Typography variant="h3" my={2}>
                  1,000 referrals = $9,000/ month in commissions.
                </Typography>
              </>
            ) : openCancel === "cancel" ? (
              <>
                <Typography variant="h5">
                  Are you sure you want to cancel subscription? Remember that results take time & that learning how to trade is an invaluable skill. 
                  BTD has bred some of the best traders around, they've had their ups & downs along the way. Patience pays off!
                </Typography>
                <List sx={{py: 2, pl: 2}}>
                  <ListItem>You will lose any active referrals.</ListItem>
                  <ListItem>Membership prices may increase soon.</ListItem>
                </List>
              </>
            ) : (
              <Typography variant="h5">
                If you want to stay, we'll offer you 50% off the annual membership. So, instead of $576, you pay $288
                today. No fine print.
              </Typography>
            )}
            {openCancel === "invite" ? (
              <Typography variant="h2" color="#039855" sx={{cursor: "pointer"}} onClick={goToReferral}>
                Awesome! I'll give it a chance.
              </Typography>
            ) : openCancel === "cancel" ? (
              <Typography variant="h2" color="#D92D20">
                This action cannot be undone.
              </Typography>
            ) : (
              ""
            )}
            <Typography
              style={{color: openCancel === "invite" ? "#039855" : "#D92D20"}}
              mt={openCancel === "cancelMember" ? "" : 2}
            >
              {openCancel === "invite"
                ? "* Results vary"
                
                : ""}
            </Typography>
          </Box>
        </Box>
        {openCancel === "cancelMember" && (
          <Box px={{sm: 3, xs: 2}}>
            <Button fullWidth className="btnInvite btnApply" onClick={getYearDiscountMembership}>
              Charge me $288. I'll stay active! <img src={arrowCircleRightDark} alt="arrow" />
            </Button>
          </Box>
        )}
        <Box p={{sm: 3, xs: 2}} mt={{sm: 4, xs: 3}} borderTop="1px solid rgba(255, 255, 255, 0.12)">
          {openCancel === "invite" ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Button fullWidth className="btnInvite" onClick={goToReferral}>
                  Invite friends instead
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button fullWidth onClick={() => setOpenCancel("cancel")}>
                  Cancel anyway
                </Button>
              </Grid>
            </Grid>
          ) : openCancel === "cancel" ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Button fullWidth className="btnGoBack" onClick={handleGoBack}>
                    Go back
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    disabled={!termAgreement}
                    onClick={() => handleCancleMember("cancelMember", termAgreement)}
                  >
                    Yes, cancel
                  </Button>
                </Grid>
              </Grid>
              <CheckboxComponent
                checked={termAgreement}
                onChange={() => setTermsAgreement(!termAgreement)}
                label="I understand that all sales are final and that there are no refunds. I understand I will lose all active referrals and my promo pricing."
              />
            </>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Button fullWidth disabled={!termAgreement} onClick={() => onCancleMember(termAgreement)}>
                    No thanks, cancel membership
                  </Button>
                </Grid>
              </Grid>
              <CheckboxComponent
                checked={termAgreement}
                onChange={() => setTermsAgreement(!termAgreement)}
                label="I understand that all sales are final and that there are no refunds. I understand I will lose all active referrals and my discounted pricing."
              />
            </>
          )}
        </Box>
        {openCancel !== "cancelMember" && (
          <CloseIcon
            sx={{position: "absolute", top: "28px", right: "28px"}}
            className={`closeModal ${openCancel === "invite" && "closeInvite"}`}
            onClick={() => setOpenCancel(false)}
          />
        )}
      </Box>
    </Modal>
  );
};

export default CancelMembershipModal;
